<div [hidden]="!isAppOnline && !gridData?.length">
  <div [hidden]="gridData?.length">
    <ng-container *ngIf="canEdit">
      <app-attachments-upload
        [fileUploadConfig]="fileUploadConfig"
        [clientId]="clientId"
        [shouldDisplayCounter]="shouldDisplayPlaceholderCounter"
        (filesUploaded)="onAttachmentsUploaded($event)"
      ></app-attachments-upload>
    </ng-container>

    <ng-container *ngIf="!canEdit">
      <div class="px-spacer-responsive py-3 border-top">
        <i i18n="@@dprDetails.dprAttachments.txtNoAttachmentUploaded">No attachment file uploaded</i>
      </div>
    </ng-container>
  </div>

  <div [hidden]="!gridData?.length">
    <app-dpr-attachments-grid
      #dprAttachmentsGrid
      [gridData]="gridData"
      [predefinedChanges]="predefinedChanges"
      [canEdit]="canEdit"
      [isAppOnline]="isAppOnline"
      [clientId]="clientId"
      [fileUploadConfig]="fileUploadConfig"
      [isAppendix]="isAppendix"
      [isNameConventionEnabled]="isNameConventionEnabled"
      [shouldDisplayPrintInReport]="shouldDisplayPrintInReport"
      [enableStickyDirective]="enableStickyDirective"
      (gridRegistered)="onGridRegistered($event)"
    ></app-dpr-attachments-grid>
  </div>
</div>

<div *ngIf="!isAppOnline && !gridData?.length">
  <div class="text-center p-3">
    <span i18n="@@dprDetails.dprAttachments.txtUploadNotAllowedWhileOffline">Upload not allowed while offline</span>
  </div>
</div>
